import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.265 2.712C8.762 1.808 9.687.7 11.224.7a2.333 2.333 0 0 1 2.108 3.333h1.559c.368 0 .666.299.666.667v3.333a.667.667 0 0 1-.666.667h-.667v6a.667.667 0 0 1-.667.667H2.891a.667.667 0 0 1-.667-.667v-6h-.666a.667.667 0 0 1-.667-.667V4.7c0-.368.298-.667.667-.667h1.558A2.333 2.333 0 0 1 5.224.7c1.538 0 2.462 1.108 2.96 2.012l.04.075zm-3.06 2.655h2.352v2H2.224v-2zm2.122-1.334a5.5 5.5 0 0 0-.312-.678c-.42-.763-.995-1.322-1.79-1.322a1 1 0 0 0-.014 2zm3.897 1.334H8.891v2h5.333v-2h-3m.707-1.627a1 1 0 0 1-.694.293H9.12c.082-.213.185-.447.312-.678.42-.763.995-1.322 1.791-1.322a1 1 0 0 1 .707 1.707m-3.04 10.293h4V8.7h-4zM7.557 8.7v5.333h-4V8.7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })